<script>
  import { Table, Spinner } from "sveltestrap";
  import NavbarSuccess from "../NavbarSuccess.svelte";
  import axios from "axios";
  import { onMount } from "svelte";
  import Task from "../containers/Task.svelte";
  import DataSpinner from "../Spinner.svelte";
  import Icon from "svelte-awesome";
  import { calendar, table } from "svelte-awesome/icons";
  import Calendar from "../containers/FieldVerificationCalendar.svelte";
  import Legends from "../Legends.svelte";
  import dayGridPlugin from "@fullcalendar/daygrid";
  import { set_attributes } from "svelte/internal";
  import ResourceTimelineGrid from '../ResourceTimelineGrid.svelte';
  import { addMonths } from 'date-fns';

  const jQuery = window.$;
  let loadedScheds = "";
  let fieldVerificationSched = {};
  let currentDate = new Date();
  let num_days = 0;
  let day = currentDate.getDate();
  let month = currentDate.getMonth() + 1;
  let cmonth = currentDate.getMonth();
  let year = currentDate.getFullYear();
  let showCalendar = false;
  let days = [];
  let month_text = null;
  let dateDay = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];
  let months = [
    { index: 1, name: "Jan" },
    { index: 2, name: "Feb" },
    { index: 3, name: "March" },
    { index: 4, name: "Apr" },
    { index: 5, name: "May" },
    { index: 6, name: "Jun" },
    { index: 7, name: "Jul" },
    { index: 8, name: "Aug" },
    { index: 9, name: "Sep" },
    { index: 10, name: "Oct" },
    { index: 11, name: "Nov" },
    { index: 12, name: "Dec" }
  ];
  let fetching = false;
  let teams;
  let TeamsLegend = [];
  let leftArrow =
    window.location.origin + "/public/assets/images/arrow-left.png";
  let rightArrow =
    window.location.origin + "/public/assets/images/arrow-right.png";
  let selectedTeam = "All";
  let eventDetails;
  let options;
  let overlayDetails;
  let HeaderMargin = 0;
  let highlightMargin = 0;
  let user = {};

  let resourceTimelineData = [];

  const cancelToken = axios.CancelToken;
  let cancelFetch = null;

  const activeRequests = {};

  onMount(async () => {
    await getUser();
    getTeam();
    DaysInMonth(0, '');
    GetScheduleByMonthAndYear(true);
  });

  $: {
    if (loadedScheds == "this" || loadedScheds == ""){
      loadedScheds = "other";
    } else if (loadedScheds == "other"){
      loadedScheds = "this";
    }

    const calendarTable = document.querySelector('#verification-table');
    const calendarHeader = document.querySelector('#table-header');
    const highlight = document.querySelector('.calendar-container .highlight');
    if (!!calendarTable && !!calendarHeader && !!highlight) {
      setTimeout(function(){
        calendarTable.style.marginLeft = calendarHeader.style.marginLeft;
        highlight.style.marginLeft = Math.abs(calendarHeader.style.marginLeft);
      },10);
    }
  }

  async function getUser() {
    const response = await fetch("/authentication/GetUserDetails");
    const responseJson = await response.json();
    user = responseJson.Result;
    if (user.Team === 100000005) {
      return;
    }

    selectedTeam = user.Team;
    localStorage.setItem("team", selectedTeam);
  }

  function DaysInMonth(dateValue, direction) {
    if (dateValue === 0) {
      return;
    }

    const currentMonth = new Date(dateValue.getFullYear(), dateValue.getMonth(), 1);
    if (direction === 'left') {
      const previousMonth = addMonths(currentMonth, -1);
      PrependSched(previousMonth.getMonth() + 1, previousMonth.getFullYear(), false);
    } else if (direction === 'right') {
      const nextMonth = addMonths(currentMonth, 1);
      AppendSched(nextMonth.getMonth() + 1, nextMonth.getFullYear(), false);
    }
  }

  function GetScheduleByMonthAndYear(initialLoad = false) {
    var prevMonth = new Date(year, month - 1, 2);
    var nextMonth = new Date(year, month, 2);

    const url = `fieldverificationapi/GetScheduleByMonthAndYear?month=${month}&year=${year}&teamFilter=${selectedTeam}`;
    if (!!activeRequests[url]) {
      return;
    } else {
      activeRequests[url] = true;
    }

    fetching = true;
    axios
      .get(url)
      .then(function(response) {
        fetching = false;
        if (initialLoad) {
          fieldVerificationSched = response.data;
        } else {
          UpdateFieldVerificationSched(response.data);
        }

        PrependSched(prevMonth.getMonth(), prevMonth.getFullYear(), true);
        AppendSched(nextMonth.getMonth() + 1, nextMonth.getFullYear(), true);

        UpdateResourceTimelineData();
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  function PrependSched(month, year, isFetching) {
    try {
      const url = `fieldverificationapi/GetScheduleByMonthAndYear?month=${month}&year=${year}&teamFilter=${selectedTeam}`;
      if (!!activeRequests[url]) {
        return;
      } else {
        activeRequests[url] = true;
      }

      if (isFetching) {
        fetching = isFetching;
      }
      axios.get(url).then(function(response){
        UpdateFieldVerificationSched(response.data);
        UpdateResourceTimelineData();

        const calendarTable = document.querySelector('#verification-table');
        const calendarHeader = document.querySelector('#table-header');
        if (!!calendarTable && !!calendarHeader) {
          calendarTable.style.marginLeft = calendarHeader.style.marginLeft;
        }

        fetching = false;
      });
    } catch (error) {
      console.log(error);
    }
  }

  function AppendSched(month, year, isFetching){
    try {
      const url = `fieldverificationapi/GetScheduleByMonthAndYear?month=${month}&year=${year}&teamFilter=${selectedTeam}`;
      if (!!activeRequests[url]) {
        return;
      } else {
        activeRequests[url] = true;
      }

      if (isFetching) {
        fetching = isFetching;
      }
      axios.get(url).then(function(response){
        UpdateFieldVerificationSched(response.data);
        UpdateResourceTimelineData();

        if (isFetching) {
          fetching = false;
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  function UpdateFieldVerificationSched(newData) {
    for (var teamIdx = 0; teamIdx < fieldVerificationSched.Team.length; teamIdx++ ) {
      const existingDataTeam = fieldVerificationSched.Team[teamIdx];
      const newDataTeam = newData.Team.find(e => e.OptionId === existingDataTeam.OptionId);
      if (!newDataTeam) {
        continue;
      }

      for (var memberIdx = 0; memberIdx < existingDataTeam.Members.length; memberIdx++ ) {
        const existingDataMember = existingDataTeam.Members[memberIdx];
        const newDataMember = newDataTeam.Members.find(e => e.MemberId === existingDataMember.MemberId);
        if (!newDataMember) {
          continue;
        }

        for (var taskIdx = 0; taskIdx < newDataMember.Task.length; taskIdx++ ){
          const newDataTask = newDataMember.Task[taskIdx];
          const existingDataTask = existingDataMember.Task.find(e => e.TaskId === newDataTask.TaskId);
          if (existingDataTask) {
            continue;
          }

          fieldVerificationSched.Team[teamIdx].Members[memberIdx].Task.push(newDataTask);
        }
      }
    }

    for (var newDataTeam of newData.Team) {
      if (!fieldVerificationSched.Team.some(e => e.OptionId === newDataTeam.OptionId)) {
        fieldVerificationSched.Team.push(newDataTeam);
      }
    }
  }

  function UpdateResourceTimelineData() {
    const confirmedColor = '#68cc7f';
    const unconfirmedColor = '#ff7070';

    let displayedTeams = fieldVerificationSched.Team;

    if (!!selectedTeam && selectedTeam !== "All") {
      displayedTeams = fieldVerificationSched.Team.filter(e => `${e.OptionId}` === `${selectedTeam}`);
    }

    resourceTimelineData = displayedTeams.map(e => ({
      id: e.OptionId,
      backgroundColor: getLegendColorByTeamName(e.TeamName),
      name: e.TeamName,
      resources: e.Members.map(f => ({
        id: f.MemberId,
        name: f.MemberName,
        entries: f.Task.map(g => ({
          id: g.TaskId,
          name: g.TaskName,
          from: new Date(g.From.replaceAll('-', '/')),
          to: new Date(g.To.replaceAll('-', '/')),
          data: g,
          backgroundColor: g.DataType === 0
            ? (g.IsConfirmed ? confirmedColor : unconfirmedColor)
            : (g.PtoRequestStatus === '100000000' ? confirmedColor : 'white'),
        })),
      })),
    }));
  }

  function handleChangeYear(e) {
    year = e.target.value;
    DaysInMonth();
    GetScheduleByMonthAndYear();
    days = days;
    console.log("year " + year);
  }

  function handleChangeMonth(e) {
    month = e.target.value;
    DaysInMonth();
    GetScheduleByMonthAndYear();
    days = days;
    console.log("month " + month);
  }
  function handleChangeTeam(e) {
    selectedTeam = e.target.value;
    getCalendarDetails();
    DaysInMonth(currentDate, '');
    GetScheduleByMonthAndYear();
  }

  async function getTeam() {
    try {
      const response = await axios.get("/FieldVerificationApi/GetTeams");
      teams = response.data;
      await getLegendColor();
    } catch (error) {
      console.log(error);
    }
  }

  async function getLegendColor() {
    try {
      const response = await axios.get("fieldverificationapi/GetLegendColor");
      TeamsLegend = response.data || [];
    } catch (error) {
      console.log(error);
    }
  }

  function getLegendColorByTeamName(teamName) {
    const legendColor = TeamsLegend.find(e => e.TeamName === teamName);
    return legendColor ? legendColor.TeamColor : 'transparent';
  }

  function handleChangeDate(e) {
    currentDate = e.detail;
    month = currentDate.getMonth() + 1;
    year = currentDate.getFullYear();
    day = currentDate.getDate();
    DaysInMonth(currentDate, '');
    var prevMonth = new Date(year, month - 1, 2);
    var nextMonth = new Date(year, month, 2);

    const url = `fieldverificationapi/GetScheduleByMonthAndYear?month=${month}&year=${year}&teamFilter=${selectedTeam}`;
    if (!!activeRequests[url]) {
      return;
    } else {
      activeRequests[url] = true;
    }

    fetching = true;
    axios
      .get(url)
      .then(function(response) {
        fetching = false;
        UpdateFieldVerificationSched(response.data);
        PrependSched(prevMonth.getMonth(), prevMonth.getFullYear(), true);
        AppendSched(nextMonth.getMonth() + 1, nextMonth.getFullYear(), true);
        UpdateResourceTimelineData();
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  function toggleCalendar() {
    showCalendar = !showCalendar;
    getCalendarDetails();
  }

  function getDay(day) {
    var dt = new Date(month + "/" + day + "/" + year);
    return dateDay[dt.getDay()];
  }

  function getCalendarDetails() {
    if(showCalendar){
      HeaderMargin = jQuery('#table-header').css("marginLeft");
    } else {
        setTimeout(function(){
          jQuery('#table-header').css("marginLeft", HeaderMargin);
          jQuery('#verification-table').css("marginLeft", HeaderMargin);
          jQuery('.calendar-container .highlight').css("marginLeft", Math.abs(HeaderMargin));
        }, 10);
    }

    if (!!cancelFetch && typeof cancelFetch === 'function') {
      cancelFetch();
    }

    new Promise(resolve => {
      if (!!user) {
        resolve();
      }

      const intervalId = setInterval(() => {
        if (!!user) {
          clearInterval(intervalId);
          resolve();
        }
      }, 100);
    })
      .then(function (response) {
        return axios
          .get(`FieldVerificationApi/GetCalendarDetails?teamFilter=${selectedTeam}`, {
            cancelToken: new axios.CancelToken(function executor(c) {
              cancelFetch = c;
            }),
          });
      })
      .then(function(response) {
        let res = response.data;

        eventDetails = res.map(e => ({
          ...e,
          backgroundColor: getLegendColorByTeamName(e.team),
        }));
        options = {
          eventClick: function(info) {
            const url = !info.event.title.startsWith('PTO')
              ? `/fieldverificationapi/getCalendarOverlay?jobid=${info.event.id}`
              : `/fieldverificationapi/getCalendarOverlayForPTO?employeePtoId=${info.event.id}`

            axios
              .get(url)
              .then(function(response) {
                overlayDetails = response.data;
                document.getElementById(
                  "calendar-overlay-content"
                ).style.display = "block";
              })
              .catch(function(error) {
                console.log(error);
              });
          },
          eventLimit: true,
          fixedWeekCount: false,
          eventLimitText: "Something",
          events: eventDetails,
          plugins: [dayGridPlugin]
        };
        options = options;
      })
      .catch(function(error) {
        if (axios.isCancel(error)) {
          console.warn("Fetch cancelled", error);
          return;
        }

        console.log(error);
      });
  }

  const today = new Date();
  const calendar_month = today.getMonth();
  const calendar_year = today.getFullYear();

  function closeOverlay() {
    document.getElementById("calendar-overlay-content").style.display = "none";
  }

  async function filteredTeamMembersAsync (members) {
    return new Promise(resolve => {
      if (!!user) {
        if (!user.IsProjectManager && !user.IsTeamLead) {
          resolve(members.filter(e => e.MemberName === user.Name));
        } else {
          resolve(members);
        }

        return;
      }

      const intervalId = setInterval(() => {
        if (!user) {
          return;
        }

        if (!user.IsProjectManager && !user.IsTeamLead) {
          resolve(members.filter(e => e.MemberName === user.Name));
        } else {
          resolve(members);
        }

        clearInterval(intervalId);
      }, 100);
    });
  }

</script>

<style>
  .timesite-container {
    position: relative;
  }
  .verification-table-container {
    margin-left: 0;
    overflow-x: auto !important;
    height: auto;
  }
  input:focus,
  textarea:focus,
  select:focus {
    outline: none !important;
  }
  .fieldverification-container {
    margin: 30px 0px;
    width: 100%;
  }

  input {
    border: none;
  }
  .datepicker {
    border-bottom: 0 !important;
    width: 200px;
    background: #fff;
    padding-left: 40px;
    top: -1px !important;
  }
  .datepicker-container {
    display: flex;
    justify-content: flex-end;
    padding: 0px 50px;
  }
  .fixed-body {
    margin-left: 0;
    position: relative;
    overflow: hidden;
  }
  tbody {
    display: flex;
  }
  .verification-table {
    margin-left: 0;
  }

  .sidebar-heading {
    background: #fff;
    min-width: 200px;
  }

  .select-container {
    margin: 0px 20px;
    width: 15%;
    font-size: 15px;
  }
  select {
    padding: 10px;
    width: 100%;
    text-align: center;
    font-size: 15px;
  }

  .td,
  th {
    height: 40px;
    vertical-align: middle;
  }

  .left-arrow {
    width: 40px;
    height: 40px;
    background: #dcdde1;
    padding: 9px 13px;
    left: 0;
    z-index: 10000;
    position: absolute;
    top: 117px !important;
  }
  .right-arrow {
    width: 40px;
    height: 40px;
    background: #dcdde1;
    position: absolute;
    padding: 9px 16px;
    right: 0;
    z-index: 9999;
    top: 117px !important;
  }
  .fixed-top {
    position: -webkit-sticky;
    position: sticky;
    text-align: center;
  }
  .calendar-container thead {
  }
  .calendar-container th {
    width: 100px;
    display: inline-block;
  }
  .calendar-heading-fix {
    position: sticky;
    top: 0;
    z-index: 99;
  }
  .calendar-container tr {
    height: 40px;
    display: flex;
  }

  .verification-filter {
    display: flex;
    margin-bottom: 20px;
  }
  .verification-filter label {
    padding-top: 8px;
    font-size: 15px;
    padding-right: 12px;
  }
  .verification-filter select {
    display: block;
    width: 30%;
    height: calc(2.5rem + 2px);
    padding: 5px;
    border: 1.5px solid #ced4da;
    border-radius: 0;
    font-size: 13px;
    margin-left: 5px;
  }
  button {
    border: none;
  }
  table {
    font-size: 12px;
  }
  .table-body {
    width: 86%;
    float: right;
  }
  .table-sidebar {
    float: left;
    width: 14%;
    z-index: 10000;
    position: relative;
  }
  .calendar-heading {
    color: #fff;
    text-align: center;
    font-weight: 400;
    background: #223646;
    font-size: 12px;
    padding: 6px 0;
    font-size: 15px;
  }
  .spinner {
    position: absolute;
    height: 100%;
    top: 50px;
    background: #fff;
    display: block;
    width: 100%;
    left: 0;
    z-index: 10000;
  }
  .calendar-top-heading {
    top: 7px;
    right: 46%;
    text-align: center;
    font-size: 140%;

    width: 100%;
    left: 0;
    right: 0;
    line-height: 22px;
    text-transform: uppercase;
    z-index: -1;
    margin-bottom: 2rem;
  }

  /*.calendar-top-heading span   {display:block}*/
  @media (max-width: 1025px) {
    .left-arrow {
      left: 20px !important;
    }
    .right-arrow {
      right: 20px !important;
    }
  }
  @media (max-width: 768px) {
    .calendar-container thead {
      display: block !important;
    }
    .job-board-filter select {
      width: 300px;
    }

    .timesite-container {
      width: 95% !important;
    }
    .verification-table thead {
      display: inline !important;
    }
    .verification-table-container .table-sidebar tr {
      border-bottom: none !important;
    }

    .verification-table-container .table-sidebar .calendar-heading {
      font-size: 10px;
    }
    .verification-table-container.table-sidebar .datepicker {
      min-width: 201px !important;
      max-width: 201px;
    }

    tr {
      border-bottom: none !important;
    }
  }
  @media (max-width: 426px) {
    .calendar-top-heading {
      font-size: 18px;
    }
    .calendar-heading {
      font-size: 10px;
    }
    .verification-table-container .table-sidebar th {
      min-width: 202px !important;
      max-width: 201px;
    }
    .right-arrow {
      right: 0 !important;
    }
    .left-arrow {
      left: 0 !important;
    }
    .field-verification-date {
      top: 11px !important;
    }
  }
  @media (max-width: 320px) {
    .job-board-filter select {
      width: 175px;
    }
  }

.field-verification-date-time {
  position: relative;
  z-index: 9999;
  width: 90px;
}
.field-verification-date {
  position: absolute;
  right: 6px;
  width: 47px;
  top: 12px;
}
.field-verification-left-date-time, .field-verification-right-date-time {
  top: 68px;
  cursor: pointer;
}
.field-verification-left-date-time input {
  opacity: 0;
  z-index: 99999;
  position: relative;
  width: 39px;
  cursor: pointer;
  height: 40px;
  top: -8px;
  left: -12px;
}
.field-verification-left-date-time img {
  position: absolute;
  top: 13px;
}
.field-verification-right-date-time input{
  opacity: 0;
  z-index: 99999;
  position: relative;
  width: 39px;
  left: -15px;
  top: -8px;
  height: 40px;
  cursor: pointer;
}
.field-verification-right-date-time img {
  position: absolute;
  top: 13px;
}
  .calendar-icon-container {
    margin-left: auto;
  }
  .field-verification-date-time {
    position: relative;
    z-index: 9999;
    width: 130px;
    padding-top: 8px;
    text-align: center;
    left: -11px;
    top: 0;
  }

    .highlight {
  width: 100px;
  position: absolute;
  height: 1145px!important;
  background: #c9d8e0;
  z-index: 9;
  opacity: 0.8;
}
.field-verification-date:focus {
    outline: none;
    box-shadow: none;
  }
  .field-verification-date {
    position: absolute;
    width: 188px;
    top: 18px;
    left: 8px;
    margin-left: -15px;
    padding-bottom: 8px;
    background: #fff;
    height: 20px;
  }
  .field-verification-left-date-time,
  .field-verification-right-date-time {
    top: 68px;
    cursor: pointer;
  }
  .field-verification-left-date-time input {
    opacity: 0;
    z-index: 99999;
    position: relative;
    width: 39px;
    cursor: pointer;
    height: 40px;
    top: -8px;
    left: -12px;
  }
  .field-verification-left-date-time img {
    position: absolute;
    top: 13px;
  }
  .field-verification-right-date-time input {
    opacity: 0;
    z-index: 99999;
    position: relative;
    width: 39px;
    left: -15px;
    top: -8px;
    height: 40px;
    cursor: pointer;
  }
  .field-verification-right-date-time img {
    position: absolute;
    top: 13px;
  }
  .timesite-container {
    width: 1280px;
    margin: 0 auto;
  }
  .highlight {
    width: 100px;
    position: absolute;
    height: 2145px !important;
    background: #c9d8e0;
    z-index: 9;
    opacity: 0.8;
  }

  .timesite-container {
    width: 1440px;
    margin: 0 auto;
  }
  .verification-table-container {
    width: 1439px;
  }
  .table-sidebar th {
    width: 217px;
    padding: 0!important;
    text-align: center;
  }
  #calendar-overlay {
    background: #fff;
    color: #000;
    height: auto;
    text-align: left;
    width: 400px;
    position: fixed;
    left: 25em;
    padding: 30px;
    top: 15em;
    border: 2px solid #495057;
    border-radius: 3px;
    text-align: left;
    left: 0;
    right: 0;
    margin: 0 auto;
    z-index: 999;
  }
  #calendar-overlay-content {
    display: none;
    height: 100%;
    width: 100%;
    left: 0;
    right: 0;
    z-index: 9;
    position: absolute;
  }
  .title {
    padding-bottom: 8px;
    border-bottom: 1px solid #eee;
    font-size: 28px;
    text-align: center;
  }
  .overlay-field {
    display: flex;
  }
  .overlay-field span {
    flex: 1;
  }
  .client-RSF {
    padding-top: 10px;
  }
  .client-RSF,
  .total-floors,
  .total-suits,
  .job-summary,
  .job-date {
    display: flex;
  }
  .client-RSF span,
  .total-floors span,
  .total-suits span,
  .job-summary span,
  .job-date span {
    flex: 1;
  }
  #calendar-overlay .fa-times {
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
  }
  .table-sidebar th {
    width: 217px;
    padding: 0 !important;
    text-align: center;
    border: 1.5px solid rgb(34 54 70 / 48%)!important;
  }

</style>

<NavbarSuccess />

<div id="calendar-overlay-content">

  <div id="calendar-overlay">
    <button on:click={closeOverlay}>
      <i class="fas fa-times" />
    </button>
    {#if overlayDetails != null}
      <div class="title">
        <span>{overlayDetails.TaskName}</span>
      </div>
      {#if !overlayDetails.TaskName.startsWith('PTO')}
        <div class="client-RSF">
          <span>Client RSF:</span>
          <span>{parseInt(overlayDetails.ClientRSF).toFixed(1)}</span>
        </div>
        <div class="total-floors">
          <span>Total Floors:</span>
          <span>{overlayDetails.TotalFloor}</span>
        </div>
        <div class="total-suits">
          <span>Total Suites:</span>
          <span>{overlayDetails.TotalSuites}</span>
        </div>
        <div class="job-summary">
          <span>Job Summary:</span>
          <span>
            {overlayDetails.JobPhase != null ? overlayDetails.JobPhase : 'Empty'}
          </span>
        </div>
        <div class="job-date">
          <span>Job Due Date:</span>
          <span>
            {overlayDetails.JobDueDate != null ? overlayDetails.JobDueDate : 'Empty'}
          </span>
        </div>
      {:else}
        <div class="overlay-field">
          <span>Employee Name:</span>
          <span>{overlayDetails.EmployeeName || 'Empty'}</span>
        </div>
        <div class="overlay-field">
          <span>Time-Off Label:</span>
          <span>{overlayDetails.PtoTimeoffLabel || 'Empty'}</span>
        </div>
        <div class="overlay-field">
          <span>Start Date:</span>
          <span>{overlayDetails.From || 'Empty'}</span>
        </div>
        <div class="overlay-field">
          <span>End Date:</span>
          <span>{overlayDetails.To || 'Empty'}</span>
        </div>
        <div class="overlay-field">
          <span>Total Hours:</span>
          <span>{overlayDetails.PtoTotalHours || 'Empty'}</span>
        </div>
        <div class="overlay-field">
          <span>Approver:</span>
          <span>{overlayDetails.PtoApproverName || 'Empty'}</span>
        </div>
        <div class="overlay-field">
          <span>Notes:</span>
          <span>{overlayDetails.PtoNotes || 'Empty'}</span>
        </div>
      {/if}
    {/if}
  </div>
</div>
<div class="timesite-container">
  <div class="verification-filter">
    <label for="">Team:</label>

    <select value={selectedTeam} on:change={handleChangeTeam}>
      {#if teams != null}
        {#each teams as team}
          <option
            value={team.Value}
            selected={localStorage.getItem('team') === team.Value ? true : false}>
            {team.Label}
          </option>
        {/each}
      {:else}
        <select>
          <option />
        </select>
        <Spinner
          size="sm"
          style="position: absolute; margin-top: 15px; margin-left: 18px;" />
      {/if}
    </select>

    <div class="spacer" style="flex-grow: 1;"></div>

    {#if showCalendar}
      <Legends legends={TeamsLegend.map(e => ({ color: e.TeamColor, label: e.TeamName}))} />
    {/if}

    <div class="spacer" style="width: 100px;"></div>

    <div class="calendar-icon-container">
      {#if !showCalendar}
        <div on:click={toggleCalendar} style="cursor: pointer">
          <Icon data={calendar} scale={3} />
        </div>
      {:else}
        <div on:click={toggleCalendar} style="cursor: pointer">
          <Icon data={table} scale={3} />
        </div>
      {/if}
    </div>
  </div>

  {#if showCalendar}
    <Calendar
      {today}
      month={calendar_month}
      year={calendar_year}
      {selectedTeam}
      {options} />
  {:else}
    <div class="calendar-top-heading">
      {currentDate.toLocaleString('default', { month: 'long', year: 'numeric' })}
    </div>
    <ResourceTimelineGrid
      bind:date={currentDate}
      data={resourceTimelineData}
      on:dateChanged={handleChangeDate} />
  {/if}
</div>
